import { Deal } from '@ca/common/types'
import ModalWide from '@ui/components/Modal/variants/ModalWide'
import useDeal from '@order/hooks/useDeal'
import { useDealSelect } from '@order/hooks/useDealTypeModal'
import useRestartOrder from '@order/hooks/useRestartOrder'
import DealsTop from '@screens/intro/deals/DealsIntro'
import { getParamsFromDeal } from '@screens/intro/deals/useCardFilter'
import { router } from 'expo-router'
import { IntroTagsSchema } from 'features/config/ConfigConditionSchemas'
import { useIsNavigationReady } from 'hooks/useIsNavigationReady'
import { useSessionDeal } from 'hooks/useSession'
import React, { useEffect, useMemo } from 'react'
import { ScrollView } from 'react-native'

/**
 * IF the callback return true will run the default logic
 */
export type DealSelectCallback = (deal: Deal) => boolean | void

interface Props {
  open: boolean
  close?: () => void
  tags: IntroTagsSchema
  onSelect?: DealSelectCallback
}

export default function DealsModal({ open, close, tags, onSelect }: Props) {
  const activeDeal = useSessionDeal()
  const isNavReady = useIsNavigationReady()

  const deal = useDeal(activeDeal?.dealId)

  const { restart: resetOrder } = useRestartOrder()
  const { selectDeal } = useDealSelect()

  const onDeal = (deal: Deal) => {
    if (!deal) {
      console.error('Deal not found', deal)
      return
    }
    resetOrder({
      avatarFlow: false,
      skipNavigate: true,
    })
    selectDeal({
      deal,
      bundle: 'base',
      onSelected: close,
    })
    if (onSelect) {
      onSelect(deal)
    }
  }

  useEffect(() => {
    if (open || !isNavReady) return
    router.setParams({ tag: undefined, type: undefined, past_deals: undefined })
  }, [open, isNavReady])

  const initial = useMemo(() => {
    return getParamsFromDeal(deal)
  }, [deal])

  return (
    <ModalWide
      open={open}
      close={close}
      hideBottomSpace
      cardComponentProps={{
        justifyContent: 'flex-start',
      }}
      body={
        <ScrollView className="h-full pt-8">
          <DealsTop
            activeId={activeDeal?.dealId}
            onSelect={onDeal}
            config={tags}
            initial={initial}
            independent
          />
        </ScrollView>
      }
    />
  )
}
